import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';

const WEBTOPICTREE = '/smarthelp/web-topic-tree';

function requestTopicTree() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTree(response, experience) {
  const topics = _get(response, 'webTopicTree');
  const blacklistedMarketICFFlag = _get(response, 'blacklistedMarketICFFlag' || false);
  return {
    type: types.RESPONSE_TOPIC_TREE,
    payload: {
      topics,
      experience,
      blacklistedMarketICFFlag,
    },
  };
}
function receiveTopicTreeError() {
  return {
    type: types.ERROR_TOPIC_TREE,
    payload: undefined,
  };
}

export default function fetchTopicTree(experience) {
  return (dispatch) => {
    dispatch(requestTopicTree());
    return axios.get(Page.setChannelForTechnicalExp(WEBTOPICTREE))
      .then((response) => dispatch(receiveTopicTree(response.data, experience)))
      .catch(() => {
        dispatch(receiveTopicTreeError());
      });
  };
}
